import React, { useEffect, useState } from "react";
import NormalTable from "../../../components/common/Tables/NormalTable";
import { getReport } from "../../../api";
import { PulseLoader } from "react-spinners";
import ExportToExcel from "../../../components/ExportToExcel/ExportToExcel";
const UserEventSummaryReport = () => {
  const [isLoading, setIsLoading] = useState(true);
const [bookingStatus, setBookingStatus] = useState<BookingReportItem[]>([]);
const [originalBookingStatus, setOriginalBookingStatus] = useState<BookingReportItem[]>([]);interface BookingReportItem {
  bookingNo: number | string;
  totalTicketAmount: string;
  discountAmount: string;
  processingFee: string;
  ticketFee: string;
  grandTotal: string;
}
  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const eventData = localStorage.getItem("eventData");
        if (eventData) {
          const eventSlug = JSON.parse(eventData).eventId;
          const venueId = localStorage.getItem("venueId");
          const response = await getReport(eventSlug);
          const filteredResponse = response.filter((item: any) => item.venueId === venueId);
          setOriginalBookingStatus(filteredResponse);
          const totalTicketAmount = filteredResponse.reduce(
            (acc: number, item: BookingReportItem) =>
              acc + (parseFloat(item.totalTicketAmount) || 0),
            0
          );
          const totalDiscount = filteredResponse.reduce(
            (acc: number, item: BookingReportItem) =>
              acc + (parseFloat(item.discountAmount) || 0),
            0
          );
          const totalProcessingFee = filteredResponse.reduce(
            (acc: number, item: BookingReportItem) =>
              acc + (parseFloat(item.processingFee) || 0),
            0
          );
          const totalTicketFee = filteredResponse.reduce(
            (acc: number, item: BookingReportItem) =>
              acc + (parseFloat(item.ticketFee) || 0),
            0
          );
          const totalGrand = filteredResponse.reduce(
            (acc: number, item: BookingReportItem) =>
              acc + (parseFloat(item.grandTotal) || 0),
            0
          );
          const totalSold = filteredResponse.length;
          const summaryRow: BookingReportItem = {
            bookingNo: totalSold.toString(),
            totalTicketAmount: totalTicketAmount.toFixed(2),
            discountAmount: totalDiscount.toFixed(2),
            processingFee: totalProcessingFee.toFixed(2),
            ticketFee: totalTicketFee.toFixed(2),
            grandTotal: totalGrand.toFixed(2),
          };
      setBookingStatus([summaryRow]);  
        }
      } catch (error) {
        console.error("Error fetching attendee report:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);
   const columns = [
    { label: "Ticket Sold", key: "bookingNo" },
    { label: "Total Ticket Amount", key: "totalTicketAmount" },
    { label: "Discount", key: "discountAmount"},
    { label: "Processing Fee", key: "processingFee"},
    { label: "Ticket Fee", key: "ticketFee"},
    { label: "Total", key: "grandTotal" },
  ];
  return (
    <div className="dashboard-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="d-main-title">
              <h3>
                <i className="mx-2">
                  <i className="fa-solid fa-chart-simple "></i>
                </i>
                Event Summary Report
              </h3>
            </div>
          </div>
          <div className="col-md-12">
            <div className="main-card mt-5">
              <div className="dashboard-wrap-content p-2">
                <div className="d-md-flex flex-wrap align-items-center">
                  <div className="dashboard-date-wrap mt-4">
                    <div className="form-group d-flex flex-column align-items-start">
                      {/* <div className="relative-input position-relative mb-2 w-100">
                        <input
                          className="form-control h_40"
                          type="text"
                          placeholder="Search by Booking No"
                          value={search}
                          onChange={handleSearch}
                        />
                        <i className="uil uil-search position-absolute"></i>
                      </div> */}

                      <div className="relative-input position-relative w-100">
                        <ExportToExcel
                          data={bookingStatus}
                          fileName="EventSummaryReport"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {isLoading ? (
                <div className="d-flex justify-content-center py-4">
                  <PulseLoader color="#ffffff" size={9} speedMultiplier={1} />
                </div>
              ) : (
                <div className="event-list">
                  <div className="tab-content">
                    <div className="tab-pane fade show active" id="orders-tab" role="tabpanel">
                      <NormalTable columns={columns} data={bookingStatus}getRowId={(row: any) => row.bookingNo}  />
                    </div>               
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UserEventSummaryReport;
